<template>
  <iframe
    id="iframeEL"
    :key="finalSrc"
    :src="finalSrc"
    width="100%"
    height="100%"
    scrolling="auto"
    frameborder="0"
    :style="{
      display: 'block',
    }"
  />
</template>

<script lang="ts" setup>
import {ref, toRefs, watch, onUnmounted, nextTick} from 'vue'
import {NIO_CONFIGURATOR_DOMAINS} from "../constants";
import {uuid} from "@common/utils";
import {setupIframeBridge} from "@/utils"
import {EventKey} from "../constants/event-key";
const props=defineProps({
  src: {
    type: String,
    default: '',
  },
})
const emit=defineEmits(['initSuccess', 'triggerEvent'])

const { src } = toRefs(props)
const finalSrc=ref('')
const iframeEL = ref<HTMLIFrameElement>();
const iframeUuid = ref('');
const iframeInitialized = ref(false)
const destroyIframeBridge = ref<()=>void>();

const registerMessageListener = () => {
  window.onmessage = (e: any) => {
    if (!NIO_CONFIGURATOR_DOMAINS.includes(e.origin)) {
      return
    }
    console.log('收到消息=>', e.data)
    if (e.data.key === EventKey.SUCCESS) {
      iframeInitialized.value = true
    } else {
      emit('triggerEvent', e.data)
    }
  }
}

const osInformation = ref({
  safeTop: 0,
  safeBottom: 0,
  systemName: '',
})

const genMessageData = (extraParams = {}) => ({
  buildEnv: process.env.TARGET, //构建环境
  safeTop: osInformation.value?.safeTop || 0,
  safeBottom: osInformation.value?.safeBottom || 0,
  systemName: osInformation.value?.systemName || '', //系统名，用于安卓安全距离处理
  ...extraParams,
})

const onIframeLoad = () => {
  emit('initSuccess')
}

watch(
    () => iframeInitialized.value,
    (newVal) => {
      if (newVal) {
        // 初始化完成,发送消息
        onIframeLoad()
      }
    }
)

const initPage = () => {
  registerMessageListener()
  iframeEL.value = document.getElementById('iframeEL') as HTMLIFrameElement
}

watch(
    src,
    () => {
      iframeUuid.value = uuid();
      finalSrc.value = `${src.value}${src.value.includes('?') ? '&' : '?'}sid=${iframeUuid.value}`;
      iframeInitialized.value = false
      nextTick(()=>{
        iframeEL.value = document.getElementById('iframeEL') as HTMLIFrameElement
      })
    },
    { immediate: true }
)

watch(iframeEL, (newVal) => {
  if (newVal) {
    destroyIframeBridge.value?.();
    destroyIframeBridge.value = setupIframeBridge(newVal, iframeUuid.value);
  } else {
    destroyIframeBridge.value?.();
  }
});
onUnmounted(() => {
  destroyIframeBridge.value?.();
});
initPage()

defineExpose({
  iframeEL,
})
</script>
